import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Input,
  FormGroup,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import NumberFormat from 'react-number-format';
import InputField from 'components/Form/Input';

const EditPhoneHome = (props) => {
  const [disabled, setDisabled] = useState(true);

  const handleValueChange = () => {
    setDisabled(false);
  };

  return (
    <Modal isOpen={props.isOpen} toggle={props.toggle} size="md">
      <ModalHeader toggle={props.toggle}>

        Edit Home Number
        <button type="button" className="close" onClick={props.toggle} aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </ModalHeader>
      <ModalBody>
        <InputField
          type="tel"
          name="home-number"
          label="Home Number"
          id="homeNumber"
          tag={NumberFormat}
          format="(###) ###-####"
          defaultValue="5551234567"
          onChange={handleValueChange}
        />

        <FormGroup check className="mb-3">
          <Input
            type="checkbox"
            name="check"
            id="Check"
            onChange={handleValueChange}
          />
          <Label for="Check" check>
            Set as primary number
          </Label>
        </FormGroup>

        <Button color="primary" className="w-100" disabled={disabled}>
          Save
        </Button>

      </ModalBody>
    </Modal>
  );
};

EditPhoneHome.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

export default EditPhoneHome;
